import { useContext } from "react";
import { getCouponDescription } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CouponDescriptionScissorIcon } from "../../client/assets/icons/common/CouponDescriptionScissorIcon";
import { CompanyContext } from "../CompanyList/CompanyContext";

const BaseCouponDescription = ({ classNames }) => {
	const { company } = useContext(CompanyContext);
	const couponDescription = useSelector((state) =>
		getCouponDescription(state, { company }),
	);
	if (!couponDescription) return null;

	return (
		<div className={classNames?.wrapper}>
			<div className={classNames?.icon?.wrapper}>
				<CouponDescriptionScissorIcon className={classNames?.icon?.content} />
			</div>
			<span className={classNames?.content}>{couponDescription}</span>
		</div>
	);
};

export default BaseCouponDescription;

BaseCouponDescription.propTypes = {
	classNames: PropTypes.shape({
		wrapper: PropTypes.string,
		icon: PropTypes.shape({
			wrapper: PropTypes.string,
			content: PropTypes.string,
		}),
		content: PropTypes.string,
	}),
};
